import { MaybeRef, computed, toValue } from 'vue'

import { useConfig } from '@/composables/config'
import { useGetExternalUrl } from '@/composables/url-helpers'
import { ROUTE_NAMES } from '@/router/constants'

export function usePartnerUrls(hru: MaybeRef<string>) {
    const { VUE_APP_HOST_URL } = useConfig()
    const getExternalUrl = useGetExternalUrl()

    const exportUrl = computed(() => {
        return (
            VUE_APP_HOST_URL +
            getExternalUrl({
                name: ROUTE_NAMES.EXPORT_GAME_PAGE,
                params: { game: toValue(hru) },
            })
        )
    })

    const partnerUrl = computed(() => {
        try {
            const urlObject = new URL('https://widgets.playgama.com/')
            urlObject.searchParams.set('gameSlug', toValue(hru))
            urlObject.searchParams.set('utm_source', 'partners_portal')
            return urlObject.toString()
        } catch {
            return 'https://widgets.playgama.com/'
        }
    })

    return { exportUrl, partnerUrl }
}
